import React, { useEffect, useRef, useState } from 'react';
import { notification,List  } from "antd";


const moment = require('moment');

const WebSocketComponent = () => {
    const [messages, setMessages] = useState(() => {
        const storedMessages = localStorage.getItem('ws_messages');
        return storedMessages ? JSON.parse(storedMessages) : [];
      });
  const ws = useRef(null);
  const [api, contextHolder] = notification.useNotification();
  const reconnectTimer = useRef(null);


  const connectWebSocket = () => {
    ws.current = new WebSocket('wss://www.skinmira.fr/ws1');

    ws.current.onopen = () => {
      console.log('✅ WebSocket connected');
      ws.current.send('Hello from client');
    };

    ws.current.onmessage = (event) => {
        try {
            if(event?.data=='Server received your message')  return

            const data = JSON.parse(event?.data || '{}');

            if (data.type === "ordercancel") {
            
              let ordercancel = data.results || [];
            
              // 🔥 防御：确保一定是数组
              if (!Array.isArray(ordercancel)) {
                ordercancel = Object.values(ordercancel);
              }
            
            setMessages(prev => {
                // 找出 prev 中不重复的消息
                const unmatchedMessages = [];
                // 遍历 ordercancel 数组
                ordercancel.forEach(order => {
                    // 检查 ordercancel 中的每个订单是否在 prev 数组中已经存在
                    const messageExists = prev.some(msg => msg.orderId === order.orderId);
                    
                    // 如果没有重复的 orderId，将其添加到 unmatchedMessages 中
                    if (!messageExists) {
                    unmatchedMessages.push(order);
                    }
                });
                if (unmatchedMessages.length > 0 && prev.length > 0) {
                    unmatchedMessages.forEach(order =>openNotification(order)())
              
            
                }
              


                // 如果找到了不重复的消息，则返回包含这些不重复消息的新数组
                if (unmatchedMessages.length > 0) {
                    console.log("有无重复订单")
                  return [...unmatchedMessages, ...prev].slice(0, 20); // 将不重复消息和新消息组合
                }
                console.log("没有无重复订单")
                // 如果没有不重复的消息，返回 prev
                return prev;
              });
            }
          
        } catch (error) {
          console.error('Error parsing message:', error);
        }
    };

    ws.current.onclose = () => {
      console.log('❌ WebSocket closed, retrying in 5s...');
      reconnectTimer.current = setTimeout(connectWebSocket, 5000); // 自动重连
    };

    ws.current.onerror = (error) => {
      console.error('⚠️ WebSocket error:', error);
      ws.current.close(); // 出错时主动关闭，触发重连
    };
  };

  useEffect(() => {
    connectWebSocket();
    return () => {
      clearTimeout(reconnectTimer.current);
      if (ws.current) ws.current.close();
    };
  }, []);
  useEffect(() => {
    localStorage.setItem('ws_messages', JSON.stringify(messages));
  }, [messages]);
  const openNotification = ({orderId ,logTime ,sku}) => () => {
    const readableTime = logTime.replace("T"," ").replace(".000Z","")
    const listsku  = sku.map(item=> <List.Item
        key={item.title}
        extra={
          <img
            width={120}
            alt="logo"
            src={item.imageUrl}
          />
        }
      >
        <List.Item.Meta
          title=      { <div>{item.barcode}<br />数量:{item.qty}</div>   }  
          description={item.brand}
        />
        {item.title}
      </List.Item>)
    api.open({
      message:       <List
      itemLayout="vertical"
      size="large"  >      
      <List.Item>
        <List.Item.Meta
      title={"订单取消"} 
    />
         <div>{orderId}<br />{readableTime}</div>
    </List.Item>
    </List>
      
        ,
      description:
      <List
      itemLayout="vertical"
      size="large"  >{listsku}</List>,
        duration:120
    });
  };

 
  return (
    <div>
  {contextHolder}

    </div>
  );
};

export default WebSocketComponent;
/*      <h2>WebSocket 通信示例</h2>

  <Button type="primary" onClick={openNotification(true)}>
          Pause on hover
        </Button>

      <ul>
        {messages.map((msg, idx) => (
          <li key={idx}>{msg}</li>
        ))}
      </ul> */